import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import "./App.css";
import { useEffect } from 'react';
import { convertFormat, submitLeads } from './utils'; // Adjust the path as needed
import image from './images/gynaecomastia.webp'; // Ensure you have an appropriate image

export const GynaecomastiaForm = () => {
  useEffect(() => {
    document.title = 'Top Gynecomastia Surgeon in Gurgaon'; // Updated title
  }, []);
  return (
    <div style={{ width: "100%", height: "100vh" }}>

      <Form
        formId="2" // Updated formId
        formObj={{
          blocks: [
            {
              name: "welcome-screen",
              id: "bph1001r",
              attributes: {
                buttonText: "Next",
                label: "<b>Top Gynecomastia Surgeon in Gurgaon<b><br>🌟🌟🌟🌟🌟",
                customHTML: `<br><b>Dr. Shikha Bansal</b><br>MBBS, MS, MCh.<br>Plastic & Reconstructive Surgery<br><h2>Regain Confidence with Gynecomastia Surgery!</h2>Expert Care for Gynecomastia&nbsp;&nbsp;✅<br>Minimally Invasive Techniques&nbsp;&nbsp;✅<br>Enhanced Aesthetic Appearance&nbsp;&nbsp;✅<br>Confidential & Compassionate Service&nbsp;&nbsp;✅`,
                attachment: {
                  type: "image",
                  url: image
                },
                attachmentMaxWidth: "350px"
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_reason",
              "attributes": {
                "required": true,
                "label": "What's your reason for exploring Gynecomastia procedure?",
                "choices": [
                  {"label": "Cosmetic improvement", "value": "cosmetic_improvement"},
                  {"label": "Health concerns", "value": "health_concerns"},
                  {"label": "Other", "value": "other"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_age_group",
              "attributes": {
                "required": true,
                "label": "What age group are you in?",
                "choices": [
                  {"label": "Below 18", "value": "below_18"},
                  {"label": "18-30", "value": "18_to_30"},
                  {"label": "31-50", "value": "31_to_50"},
                  {"label": "51-65", "value": "51_to_65"},
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_location",
              "attributes": {
                "required": true,
                "label": "Where are you located?",
                "choices": [
                  {"label": "Gurgaon", "value": "gurgaon"},
                  {"label": "Delhi", "value": "delhi"},
                  {"label": "Faridabad", "value": "faridabad"},
                  {"label": "Ghaziabad", "value": "ghaziabad"},
                  {"label": "Other", "value": "other"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_when",
              "attributes": {
                "required": true,
                "label": "How soon are you looking for a treatment?",
                "choices": [
                  {"label": "As soon as possible", "value": "asap"},
                  {"label": "Within a week", "value": "within_a_week"},
                  {"label": "Within a month", "value": "within_a_month"},
                  {"label": "> 1 month", "value": "more_than_a_month"},
                  {"label": "Not sure", "value": "not_sure"}
                ]
              }
            },
            {
              name: "short-text",
              id: "name",
              attributes: {
                required: true,
                label: "What's your name?"
              }
            },
            {
              name: "number",
              id: "phone",
              attributes: {
                required: true,
                description: "We value your trust and privacy. Your phone number will be securely shared with our doctor for necessary communication only!",
                label: "What's your phone number?"
              }
            },
          ],
          messages: {
            'block.defaultThankYouScreen.label': 'Thank you! We will contact you shortly!'
          },
          settings: {
            animationDirection: "vertical",
            disableWheelSwiping: false,
            disableNavigationArrows: false,
            disableProgressBar: false,
            showQuestionsNumbers: true
          },
          theme: {
            font: "Roboto",
            questionsColor: "#1c3d5a",
            buttonsBgColor: "#1c3d5a",
            logo: {
              src: ""
            },
            answersColor: "#1c3d5a",
            buttonsFontColor: "#fff",
            buttonsBorderRadius: 25,
            errorsFontColor: "#fff",
            errorsBgColor: "#f00",
            progressBarFillColor: "#1c3d5a",
            progressBarBgColor: "#ccc"
          }
        }}
        onSubmit={(data, { completeForm, setIsSubmitting, setSubmissionErr }) => {
          let convertedData = convertFormat(data);
          convertedData['type'] = 'gynaecomastia'
          console.log(JSON.stringify(convertedData));
          let mode = window.location.hostname === 'localhost' ? 'dev' : 'prod';
          submitLeads(convertedData, { mode, targets: 'both', successPolicy: 'any', mockSuccess: true })
            .then(() => {
              setIsSubmitting(false);
              completeForm();
              setTimeout(() => {
                window.location.href = 'https://drshikhabansal.com';
              }, 3000);
            })
            .catch((error) => {
              setIsSubmitting(false);
              setSubmissionErr(error.message);
              console.error('Lead submission error details:', error.result || error);
            });
        }}
      />
    </div>
  );
};
